import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import { FIX_LOCATION } from 'app/constants/hint';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingObserverForm({ updateLocation, users, observerManager }) {
  return (
    <LocationRoleUsersForm
      updateLocation={updateLocation}
      users={users}
      fields={[
        {
          name: 'observer_ids',
          role: 'observer',
          title: '观察员',
          hint: FIX_LOCATION.observer,
          selectedUsers: observerManager
        }
      ]}
    />
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  return {
    users: selectors.getSpaceUsers(state),
    observerManager: selectors.getTeamRolesOfLocation(state, loc_id, 'observer')
  };
}

export default connect(mapStateToProps)(LocationSettingObserverForm);
